<template>
  <layout-default :show-backpack="false" :show-promo-message="false"> 
    <!--main-banner></main-banner-->
    <Banner></Banner>
    <Puntajes />
    <Programs />
    <!--important-info-section></important-info-section-->
    <!--        todo: Descomentar el siguiente boton cuando sea indicado>
    <button type="button" id="chat-button" class="float-chat-button" onclick="customPlugin.command('WebChat.open', getAdvancedConfig());"><img
                src="/images/iconos/PdV_mensaje_chat.svg" alt=""></button-->  
  </layout-default>
</template>

<script>
    import MainBanner from "@/components/MainBanner";
    import ImportantInfoSection from "@/components/ImportantInfoSection";
    import LayoutDefault from "@/layouts/Default";
    import Button from "@/components/featured/Button";
    import Banner from "@/components/featured/home/Banner";
    import Puntajes from "@/components/featured/home/Puntajes";
    import Programs from "@/components/featured/home/Programs";

    export default {
        components: {
            MainBanner,
            ImportantInfoSection,
            LayoutDefault,
            Button,
            Banner,
            Puntajes,
            Programs
        },
        data(){
            return {
                showModal: false
            }
        },
        mounted(){
            localStorage.clear();
            var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date();
            (function(){
            var s1=document.createElement("script"),s0=document.getElementsByTagName("script")[0];
            s1.async=true;
            s1.src='https://embed.tawk.to/60c91eb57f4b000ac037ce23/1f88pvtk9';
            s1.charset='UTF-8';
            s1.setAttribute('crossorigin','*');
            s0.parentNode.insertBefore(s1,s0);
            })();


            if(this.$route.query.transactionFailed){
                //open modal
                const errName = this.$route.query.transactionFailed;
                if(errName === 'time_expired'){
                    window.$('#helperSessionClosedModal')[0].click();
                }
            }

        },
        methods: {
            closeModal(){
                this.showModal = false
            }, 
        }
    };

</script>

<style lang="scss" scoped>
    .float-chat-button{
        position: fixed;
        right: 55px;
        bottom: 60px;
        z-index: 1000;
        background: transparent;
        box-shadow: none;
    }
</style>
